import React from "react";
import styled from "styled-components";
import {InputLabel} from "@/components/inputs";
import {Button} from "@/components/buttons";
import {ButtonProps, PropsInput} from "@/components/props";
import {observer} from "mobx-react-lite";
import {IEmailPasswordRecovery} from "@/types/auth";
import {EmailPasswordRecovery} from "@/models/auth";
import {useEnterKeydown, useFormikConfig, useSubmitting} from "@/pages/login/hooks";
import {useStore} from "@/store";
import {onSubmitSendEmailPasswordRecovery} from "@/pages/login/submits";


export const EmailForm = observer(() => {
    const {formActiveStore: {setFormActive}} = useStore()
    const [isFocus, setIsFocus] = React.useState<boolean>(false);

    const onSubmit = () => onSubmitSendEmailPasswordRecovery(formik, setFormActive);

    const initialValues: IEmailPasswordRecovery = new EmailPasswordRecovery();
    const validationSchema = (initialValues as EmailPasswordRecovery).validationSchema();
    const formik = useFormikConfig<IEmailPasswordRecovery>(initialValues, onSubmit, validationSchema);
    useSubmitting(formik);
    useEnterKeydown(isFocus, onSubmit, setIsFocus);


    const emailProps: PropsInput = {
        name: 'email',
        label: 'Email',
        error: formik.touched.email && formik.errors.email,
        placeholder: 'Введите ваш e-mail',
        value: formik.values.email,
        type: 'text',
        colorError: 'red',
        onChange: formik.handleChange,
        onBlur: formik.handleBlur,
        autoComplete: 'off',
        onFocus: () => setIsFocus(true)
    }
    const buttonProps: ButtonProps = {
        type: 'submit',
        disabled: !formik.isValid || formik.isSubmitting,

    }
    return (
        <form onSubmit={formik.handleSubmit}>
            <InputLabel {...emailProps}/>
            <Span>
                Вам будет направлено письмо с одноразовым кодом на ваш email
            </Span>
            <Button {...buttonProps}> Продолжить</Button>

        </form>
    )
})

export default EmailForm;

const Span = styled.span`
  text-align: center;
  color: rgba(255, 255, 255, 0.8);
  margin-top: -13px;
`;